<template>
  <div>
    <div class="card card-custom card-sticky" v-if="!mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer">
            <span class="label label-xl label-dot label-primary mr-2"></span> Turno 1 - Mesa (06:00 - 13:00)
            <small v-if="ui.estaCargandoDatos">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{
              auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="doCargarFicha()"><i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin ' : '']"></i></a>
        </div>
      </div>
    </div>
    <div class="card card-custom card-sticky" v-if="mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
            <span class="label label-xl label-dot label-primary mr-2"></span> Turno 1 - Mesa
            <small>{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" @click.prevent="doGuardado()"><i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i> Guardar
            cambios</a>
          <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="$emit('update:expandirContenido', !expandirContenido)"><i class="fa p-0" :class="[expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
        </div>
      </div>
      <div class="card-body px-3 px-md-9 py-4 py-md-8" v-show="expandirContenido">
        <div class="alert alert-light p-6">
          <h4 class="mb-3 font-weight-bold">Registro de Asistencia</h4>
          <form class="form" id="frm-mesa-turno-1-asistencia" @submit.prevent>
            <div class="row">
              <div class="form-group col-12 col-md-3">
                <label class="mb-1">Nombre del Observador</label>
                <input type="text" class="form-control" v-model="actual.t1ObservadorNombre" placeholder="Nombres y apellidos" autocomplete="off" required />
              </div>
              <div class="form-group col-12 col-md-3">
                <label class="mb-1">DNI</label>
                <input type="text" class="form-control" v-model="actual.t1ObservadorDni" placeholder="Número de documento de identidad" autocomplete="off" required />
              </div>
              <div class="form-group col-12 col-md-3">
                <label class="mb-1">Local de Votación</label>
                <input type="text" class="form-control" :value="localNombre" disabled />
              </div>
              <div class="form-group col-12 col-md-3">
                <label class="mb-1">Nro. de Mesa</label>
                <input type="text" class="form-control" v-model="actual.t1NumeroMesaIngresado" placeholder="Número de mesa..." autocomplete="off" required />
                <small v-if="actual.t1NumeroMesaIngresado && !numeroMesaConfirmado" class="text-danger">El número ingresado no
                  coincide con el de la mesa asignada.</small>
              </div>
              <div class="form-group col-12">
                <label class="mb-1 font-weight-bold">Registro de asistencia</label>
                <div class="btn-group d-flex flex-wrap" role="group">
                  <!-- <button type="button" @click.prevent="seleccionarTipoRegistroAsistencia(1)" class="btn flex-fill" :class="[actual.t1TipoRegistroAsistencia === 1 ? 'btn-primary' : 'btn-outline-secondary']"><i class="fa fa-door-open mr-2"></i>Ingresé al local de votación</button> -->
                  <button type="button" @click.prevent="seleccionarTipoRegistroAsistencia(2)" class="btn flex-fill" :class="[actual.t1TipoRegistroAsistencia === 2 ? 'btn-success' : 'btn-outline-secondary']"><i class="fa fa-check mr-2"></i>Llegué a la mesa asignada</button>
                  <button type="button" @click.prevent="seleccionarTipoRegistroAsistencia(3)" class="btn flex-fill" :class="[actual.t1TipoRegistroAsistencia === 3 ? 'btn-danger' : 'btn-outline-secondary']"><i class="fa fa-ban mr-2"></i>No se permitió el ingreso para la observación electoral</button>
                </div>
                <div v-if="actual.t1TipoRegistroAsistencia === 1" class="alert alert-custom alert-light-info mt-3 mb-0 py-2">
                  <i class="fa fa-info-circle mr-1"></i> Has registrado que ingresaste al local pero no llegaste a la mesa. No es necesario completar el cuestionario.
                </div>
                <div v-if="actual.t1TipoRegistroAsistencia === 3" class="alert alert-custom alert-light-warning mt-3 mb-0 py-2">
                  <i class="fa fa-info-circle mr-1"></i> Has registrado que no se permitió el ingreso. No es necesario completar el cuestionario.
                </div>
              </div>
            </div>
          </form>
        </div>
        <form v-show="registroAsistenciaCompleto" class="form" id="frm-mesa-turno-1">
          <div class="row">
            <div class="col-xl-2 d-none d-xl-block"></div>
            <div class="col-12 col-xl-8">

              <!-- BLOQUE 2: Instalación de Mesa -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">II. Instalación de Mesa</h3> -->

                <div :class="sheetRowQClass(true, sheetP1Completa)">
                  <label :class="ui.colLeftClass">1. ¿Ya se instaló la mesa de votación?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1MesaInstalada = true" class="btn" :class="[actual.t1MesaInstalada === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="limpiarInstalacionMesa(false)" class="btn" :class="[actual.t1MesaInstalada === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>

                    <!-- Mesa instalada -->
                    <div v-if="actual.t1MesaInstalada === true" class="mt-3">
                      <b-form-radio size="lg" v-model="t1TipoInstalacion" value="solo" class="mb-2">a) Solo con
                        miembros de mesa titulares y/o suplentes</b-form-radio>
                      <b-form-radio size="lg" v-model="t1TipoInstalacion" value="fila" class="mb-2">b) Con al menos
                        una persona de la fila</b-form-radio>
                      <div class="mt-3">
                        <label>c) ¿En qué rango de hora se instaló la Mesa de Votación?</label>
                        <div class="btn-group d-flex flex-wrap mt-1" role="group">
                          <button v-for="rango in rangosHora" :key="rango.valor" type="button" @click.prevent="actual.t1RangoHoraInstalacion = actual.t1RangoHoraInstalacion === rango.valor ? null : rango.valor" class="btn btn-sm" :class="[actual.t1RangoHoraInstalacion === rango.valor ? 'btn-primary' : 'btn-outline-secondary']">
                            {{ rango.etiqueta }}
                          </button>
                        </div>
                        <textarea v-if="actual.t1RangoHoraInstalacion" v-model="actual.t1RangoHoraInstalacionDetalle" class="form-control mt-2" :placeholder="actual.t1RangoHoraInstalacion === 8 ? 'Observaciones sobre la hora de instalación...' : 'Observaciones sobre la hora de instalación (opcional)...'" :required="actual.t1RangoHoraInstalacion === 8"></textarea>
                      </div>
                    </div>

                    <!-- Mesa no instalada -->
                    <div v-if="actual.t1MesaInstalada === false" class="mt-3">
                      <label class="mb-1">Motivo(s) de no instalación:</label>
                      <b-form-checkbox size="lg" v-model="actual.t1NoInstalAusenciaMiembrosMesa" class="mb-2">Ausencia
                        de miembros de mesa</b-form-checkbox>
                      <b-form-checkbox size="lg" v-model="actual.t1NoInstalFaltaMaterialElectoral" class="mb-2">Falta de
                        material electoral</b-form-checkbox>
                      <b-form-checkbox size="lg" v-model="actual.t1NoInstalDesastresNaturales" class="mb-2">Desastres
                        naturales</b-form-checkbox>
                      <b-form-checkbox size="lg" v-model="actual.t1NoInstalOtros" class="mb-2">Otros</b-form-checkbox>
                      <textarea v-if="actual.t1NoInstalOtros" v-model="actual.t1NoInstalOtrosDetalle" class="form-control mt-2" placeholder="Describa el motivo..."></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP12Completa)">
                  <label :class="ui.colLeftClass">1.1. ¿Los miembros de mesa recibieron el material electoral para la instalación de la mesa de votación completo por parte de ONPE?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1MaterialElectoralCompletoOnpe = true; actual.t1MaterialElectoralCompletoOnpeDetalle = null" class="btn" :class="[actual.t1MaterialElectoralCompletoOnpe === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1MaterialElectoralCompletoOnpe = false" class="btn" :class="[actual.t1MaterialElectoralCompletoOnpe === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t1MaterialElectoralCompletoOnpe === false">
                      <textarea v-model="actual.t1MaterialElectoralCompletoOnpeDetalle" class="form-control mt-2" placeholder="Señale brevemente qué material faltó o por qué no estuvo completo..." required></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <!-- BLOQUE 3: Entorno y Presencia -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">III. Entorno y Presencia</h3> -->
                <div v-if="!actual.t1MesaInstalada">
                  <div class="alert alert-custom alert-light-info mt-2 mb-0 py-2"><i class="fa fa-info-circle mr-1"></i> Esta sección sólo debe ser completada si la mesa de votación fue instalada. </div>
                </div>

                <div v-else>
                  <div :class="sheetRowQClass(true, sheetP2Completa)">
                    <label :class="ui.colLeftClass">2. ¿Se registra la presencia de personeros en la etapa de Instalación de la Mesa?</label>
                    <div :class="ui.colRightClass">
                      <div class="btn-group" role="group">
                        <button type="button" @click.prevent="actual.t1PresenciaPersoneros = true" class="btn" :class="[actual.t1PresenciaPersoneros === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                        <button type="button" @click.prevent="limpiarCampoConOrganizacion('t1PresenciaPersoneros', 't1PresenciaPersonerosOrganizacionParamId')" class="btn" :class="[actual.t1PresenciaPersoneros === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                      </div>
                      <div v-if="actual.t1PresenciaPersoneros === true" class="mt-2">
                        <label class="mb-1">Organización política:</label>
                        <div class="btn-group d-flex flex-wrap" role="group">
                          <button v-for="partido in partidosNacionales" :key="partido.parametroId" type="button" @click.prevent="togglePartidoCsv('t1PresenciaPersonerosOrganizacionParamIds', partido.parametroId)" class="btn btn-sm" :class="[isPartidoSelected('t1PresenciaPersonerosOrganizacionParamIds', partido.parametroId) ? 'btn-primary' : 'btn-outline-secondary']">
                            <img :src="getImagenPartidoPolitico(partido.parametroId)" style="height:20px;width:auto;vertical-align:middle;" class="mr-1" />
                            {{ partido.descripcion }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div :class="sheetRowQClass(true, sheetP3Completa)">
                    <label :class="ui.colLeftClass">3. ¿Ves algún tipo de propaganda electoral cerca de tu mesa?</label>
                    <div :class="ui.colRightClass">
                      <div class="btn-group" role="group">
                        <button type="button" @click.prevent="actual.t1PropagandaCercaMesa = true" class="btn" :class="[actual.t1PropagandaCercaMesa === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                        <button type="button" @click.prevent="limpiarPropagandaMesa()" class="btn" :class="[actual.t1PropagandaCercaMesa === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                      </div>
                      <div v-if="actual.t1PropagandaCercaMesa === true" class="mt-2">
                        <label class="mb-1">Organización política:</label>
                        <div class="btn-group d-flex flex-wrap" role="group">
                          <button v-for="partido in partidosNacionales" :key="partido.parametroId" type="button" @click.prevent="togglePartidoCsv('t1PropagandaCercaMesaOrganizacionParamIds', partido.parametroId)" class="btn btn-sm" :class="[isPartidoSelected('t1PropagandaCercaMesaOrganizacionParamIds', partido.parametroId) ? 'btn-primary' : 'btn-outline-secondary']">
                            <img :src="getImagenPartidoPolitico(partido.parametroId)" style="height:20px;width:auto;vertical-align:middle;" class="mr-1" />
                            {{ partido.descripcion }}
                          </button>
                        </div>
                        <small v-if="parsePartidoIds(actual.t1PropagandaCercaMesaOrganizacionParamIds).length === 0" class="text-danger d-block mt-1">Selecciona al menos una organización política.</small>
                        <textarea v-model="actual.t1PropagandaCercaMesaDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                      </div>
                    </div>
                  </div>

                  <div :class="sheetRowQClass(true, sheetP4Completa)">
                    <label :class="ui.colLeftClass">4. ¿Fue fácil identificar el número de la mesa de votación asignada?</label>
                    <div :class="ui.colRightClass">
                      <div class="btn-group" role="group">
                        <button type="button" @click.prevent="actual.t1FacilIdentificarNumeroMesa = true" class="btn" :class="[actual.t1FacilIdentificarNumeroMesa === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                        <button type="button" @click.prevent="actual.t1FacilIdentificarNumeroMesa = false" class="btn" :class="[actual.t1FacilIdentificarNumeroMesa === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                      </div>
                      <div v-if="actual.t1FacilIdentificarNumeroMesa === false">
                        <textarea v-model="actual.t1FacilIdentificarNumeroMesaDetalle" class="form-control mt-2" placeholder="Señale brevemente el motivo..." required></textarea>
                      </div>
                    </div>
                  </div>

                  <div :class="sheetRowQClass(true, sheetP5Completa)">
                    <label :class="ui.colLeftClass">5. ¿Se brinda atención preferencial a personas con discapacidad, embarazadas y/o adultos mayores en la mesa de votación? Nota: Se refiere a asistencia</label>
                    <div :class="ui.colRightClass">
                      <div class="btn-group" role="group">
                        <button type="button" @click.prevent="actual.t1AtencionPreferencial = true" class="btn" :class="[actual.t1AtencionPreferencial === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                        <button type="button" @click.prevent="actual.t1AtencionPreferencial = false" class="btn" :class="[actual.t1AtencionPreferencial === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                      </div>
                      <div v-if="actual.t1AtencionPreferencial === false">
                        <textarea v-model="actual.t1AtencionPreferencialDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- BLOQUE 4: Incidencias -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">IV. Incidencias</h3> -->

                <div :class="sheetRowQClass(true, sheetP6Completa)">
                  <label :class="ui.colLeftClass">6. ¿Se presentó/produjo algún incidente que limita o impide el ejercicio de tus funciones como observador/a electoral?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1IncidenteLimitaLaborObservador = true" class="btn" :class="[actual.t1IncidenteLimitaLaborObservador === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1IncidenteLimitaLaborObservador = false" class="btn" :class="[actual.t1IncidenteLimitaLaborObservador === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t1IncidenteLimitaLaborObservador === true">
                      <textarea v-model="actual.t1IncidenteLimitaLaborObservadorDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                    <div v-if="actual.t1IncidenteLimitaLaborObservador === true" class="alert alert-custom alert-light-warning mt-2 mb-0 py-2">
                      <i class="fa fa-bell mr-1"></i> Recuerda que también debes registrar la información en el botón de
                      alerta.
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetP7Completa)">
                  <label :class="ui.colLeftClass">7. ¿Se ha detectado algún acto de intimidación, coacción, agresión o violencia que impida el ejercicio del voto ciudadano en tu mesa de votación?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1ActoIntimidacionOViolencia = true" class="btn" :class="[actual.t1ActoIntimidacionOViolencia === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1ActoIntimidacionOViolencia = false" class="btn" :class="[actual.t1ActoIntimidacionOViolencia === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t1ActoIntimidacionOViolencia === true">
                      <textarea v-model="actual.t1ActoIntimidacionOViolenciaDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                    <div v-if="actual.t1ActoIntimidacionOViolencia === true" class="alert alert-custom alert-light-warning mt-2 mb-0 py-2">
                      <i class="fa fa-bell mr-1"></i> Recuerda que también debes registrar la información en el botón de
                      alerta.
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-xl-2 d-none d-xl-block"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { sheetBoolAnswered, sheetNonEmpty } from "@/helpers/sheetQuestion.js";

export default {
  name: "ficha-mesa-turno-1-2026",
  props: {
    mesaVotacionId: { type: Number },
    localVotacionId: { type: Number },
    procesoElectoralId: { type: Number },
    expandirContenido: { type: Boolean },
    intervaloAutoGuardado: { type: Number },
  },
  data: () => ({
    auth: {
      autorizadoEdicionTurno: null,
      mensajeNoAutorizadoEdicionTurno: null,
      fechaInicioTurno: null,
      fechaFinTurno: null,
    },
    ui: {
      colLeftClass: "col-12 col-md-5 col-form-label",
      colRightClass: "col-12 col-md-7",
      estaGuardando: false,
      estaCargandoDatos: false,
      tieneCargaInicial: false,
    },
    rangosHora: [
      { valor: 1, etiqueta: "06:00 - 06:30" },
      { valor: 2, etiqueta: "06:30 - 07:00" },
      { valor: 3, etiqueta: "07:00 - 08:00" },
      { valor: 4, etiqueta: "08:00 - 09:00" },
      { valor: 5, etiqueta: "09:00 - 10:00" },
      { valor: 6, etiqueta: "10:00 - 11:00" },
      { valor: 7, etiqueta: "11:00 - 12:00" },
      { valor: 8, etiqueta: "12:00 - 13:00" },
    ],
    temporizadorGuardado: null,
    numeroMesaEsperado: null,
    localNombre: null,
    actual: {
      t1ObservadorNombre: null,
      t1ObservadorDni: null,
      t1TipoRegistroAsistencia: null,
      t1NumeroMesaIngresado: null,
      t1MesaInstalada: null,
      t1InstaladaSoloMiembrosMesa: null,
      t1InstaladaConPersonaDeLaFila: null,
      t1RangoHoraInstalacion: null,
      t1RangoHoraInstalacionDetalle: null,
      t1NoInstalAusenciaMiembrosMesa: null,
      t1NoInstalFaltaMaterialElectoral: null,
      t1NoInstalDesastresNaturales: null,
      t1NoInstalOtros: null,
      t1NoInstalOtrosDetalle: null,
      t1MaterialElectoralCompletoOnpe: null,
      t1MaterialElectoralCompletoOnpeDetalle: null,
      t1PresenciaPersoneros: null,
      t1PresenciaPersonerosOrganizacionParamId: null,
      t1PresenciaPersonerosOrganizacionParamIds: null,
      t1PropagandaCercaMesa: null,
      t1PropagandaCercaMesaOrganizacionParamId: null,
      t1PropagandaCercaMesaOrganizacionParamIds: null,
      t1PropagandaCercaMesaDetalle: null,
      t1FacilIdentificarNumeroMesa: null,
      t1FacilIdentificarNumeroMesaDetalle: null,
      t1AtencionPreferencial: null,
      t1AtencionPreferencialDetalle: null,
      t1IncidenteLimitaLaborObservador: null,
      t1IncidenteLimitaLaborObservadorDetalle: null,
      t1ActoIntimidacionOViolencia: null,
      t1ActoIntimidacionOViolenciaDetalle: null,
    },
    guardado: {
      t1ObservadorNombre: null,
      t1ObservadorDni: null,
      t1TipoRegistroAsistencia: null,
      t1NumeroMesaIngresado: null,
      t1MesaInstalada: null,
      t1InstaladaSoloMiembrosMesa: null,
      t1InstaladaConPersonaDeLaFila: null,
      t1RangoHoraInstalacion: null,
      t1RangoHoraInstalacionDetalle: null,
      t1NoInstalAusenciaMiembrosMesa: null,
      t1NoInstalFaltaMaterialElectoral: null,
      t1NoInstalDesastresNaturales: null,
      t1NoInstalOtros: null,
      t1NoInstalOtrosDetalle: null,
      t1MaterialElectoralCompletoOnpe: null,
      t1MaterialElectoralCompletoOnpeDetalle: null,
      t1PresenciaPersoneros: null,
      t1PresenciaPersonerosOrganizacionParamId: null,
      t1PresenciaPersonerosOrganizacionParamIds: null,
      t1PropagandaCercaMesa: null,
      t1PropagandaCercaMesaOrganizacionParamId: null,
      t1PropagandaCercaMesaOrganizacionParamIds: null,
      t1PropagandaCercaMesaDetalle: null,
      t1FacilIdentificarNumeroMesa: null,
      t1FacilIdentificarNumeroMesaDetalle: null,
      t1AtencionPreferencial: null,
      t1AtencionPreferencialDetalle: null,
      t1IncidenteLimitaLaborObservador: null,
      t1IncidenteLimitaLaborObservadorDetalle: null,
      t1ActoIntimidacionOViolencia: null,
      t1ActoIntimidacionOViolenciaDetalle: null,
    },
    partidos: [],
  }),
  computed: {
    t1TipoInstalacion: {
      get() {
        if (this.actual.t1InstaladaSoloMiembrosMesa) return 'solo';
        if (this.actual.t1InstaladaConPersonaDeLaFila) return 'fila';
        return null;
      },
      set(val) {
        this.actual.t1InstaladaSoloMiembrosMesa = val === 'solo' ? true : null;
        this.actual.t1InstaladaConPersonaDeLaFila = val === 'fila' ? true : null;
      },
    },
    partidosNacionales() {
      return (this.partidos || []).filter(p => p.regionId == 0);
    },
    isDirty() {
      return JSON.stringify(this.actual) != JSON.stringify(this.guardado);
    },
    mostrarDetalleFicha() {
      return this.ui.tieneCargaInicial && !!this.auth.autorizadoEdicionTurno;
    },
    numeroMesaConfirmado() {
      var ingresado = (this.actual.t1NumeroMesaIngresado || "").toString().trim();
      var esperado = (this.numeroMesaEsperado || "").toString().trim();
      return esperado.length > 0 && ingresado === esperado;
    },
    datosAsistenciaValidos() {
      var nombre = (this.actual.t1ObservadorNombre || "").toString().trim();
      var dni = (this.actual.t1ObservadorDni || "").toString().trim();
      return nombre.length > 0 && dni.length > 0 && this.numeroMesaConfirmado;
    },
    registroAsistenciaCompleto() {
      return this.datosAsistenciaValidos && this.actual.t1TipoRegistroAsistencia === 2;
    },
    sheetP1Completa() {
      const m = this.actual.t1MesaInstalada;
      if (!sheetBoolAnswered(m)) return false;
      if (m === true) {
        if (!this.t1TipoInstalacion) return false;
        if (this.actual.t1RangoHoraInstalacion == null) return false;
        if (this.actual.t1RangoHoraInstalacion === 8 && !sheetNonEmpty(this.actual.t1RangoHoraInstalacionDetalle)) return false;
        return true;
      }
      const a = this.actual.t1NoInstalAusenciaMiembrosMesa;
      const b = this.actual.t1NoInstalFaltaMaterialElectoral;
      const c = this.actual.t1NoInstalDesastresNaturales;
      const d = this.actual.t1NoInstalOtros;
      const algunaRazon = !!(a || b || c || d);
      if (!algunaRazon) return false;
      if (d && !sheetNonEmpty(this.actual.t1NoInstalOtrosDetalle)) return false;
      return true;
    },
    sheetP12Completa() {
      const x = this.actual.t1MaterialElectoralCompletoOnpe;
      if (!sheetBoolAnswered(x)) return false;
      if (x === false) return sheetNonEmpty(this.actual.t1MaterialElectoralCompletoOnpeDetalle);
      return true;
    },
    sheetP2Completa() {
      if (this.actual.t1MesaInstalada !== true) return true;
      return sheetBoolAnswered(this.actual.t1PresenciaPersoneros);
    },
    sheetP3Completa() {
      if (this.actual.t1MesaInstalada !== true) return true;
      const x = this.actual.t1PropagandaCercaMesa;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) {
        if (this.parsePartidoIds(this.actual.t1PropagandaCercaMesaOrganizacionParamIds).length === 0) return false;
        return sheetNonEmpty(this.actual.t1PropagandaCercaMesaDetalle);
      }
      return true;
    },
    sheetP4Completa() {
      if (this.actual.t1MesaInstalada !== true) return true;
      const x = this.actual.t1FacilIdentificarNumeroMesa;
      if (!sheetBoolAnswered(x)) return false;
      if (x === false) {
        return sheetNonEmpty(this.actual.t1FacilIdentificarNumeroMesaDetalle);
      }
      return true;
    },
    sheetP5Completa() {
      if (this.actual.t1MesaInstalada !== true) return true;
      const x = this.actual.t1AtencionPreferencial;
      if (!sheetBoolAnswered(x)) return false;
      if (x === false) {
        return sheetNonEmpty(this.actual.t1AtencionPreferencialDetalle);
      }
      return true;
    },
    sheetP6Completa() {
      const x = this.actual.t1IncidenteLimitaLaborObservador;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) {
        return sheetNonEmpty(this.actual.t1IncidenteLimitaLaborObservadorDetalle);
      }
      return true;
    },
    sheetP7Completa() {
      const x = this.actual.t1ActoIntimidacionOViolencia;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) {
        return sheetNonEmpty(this.actual.t1ActoIntimidacionOViolenciaDetalle);
      }
      return true;
    },
  },
  methods: {
    sheetRowQClass(aplica, completa) {
      if (!aplica) return ["form-group", "row"];
      return ["form-group", "row", "sheet-question", completa ? "sheet-question--completada" : "sheet-question--pendiente"];
    },
    fetchPartidosPoliticos() {
      this.$http.get(this.apiRoute("Parameter", "ListParametrosPoliticos"), { params: { Id: this.localVotacionId } })
        .then(function (response) { this.partidos = response.body.data; });
    },
    getImagenPartidoPolitico(partidoPoliticoParamId) {
      var partido = this.partidos.find(x => x.parametroId == partidoPoliticoParamId);
      var imagen = partido ? partido.imagen : "app-partidos/_no-image.png";
      return `${this.apiResource(imagen)}`;
    },
    toggleOrganizacion(campo, parametroId) {
      this.actual[campo] = this.actual[campo] === parametroId ? null : parametroId;
    },
    parsePartidoIds(csv) {
      if (!csv) return [];
      return csv.toString().split(",").map(s => parseInt(s, 10)).filter(n => !isNaN(n));
    },
    isPartidoSelected(campo, parametroId) {
      return this.parsePartidoIds(this.actual[campo]).indexOf(parametroId) !== -1;
    },
    togglePartidoCsv(campo, parametroId) {
      var ids = this.parsePartidoIds(this.actual[campo]);
      var idx = ids.indexOf(parametroId);
      if (idx === -1) ids.push(parametroId);
      else ids.splice(idx, 1);
      this.actual[campo] = ids.length ? ids.join(",") : null;
    },
    validarRegistroAsistencia() {
      return this.isFormValid("frm-mesa-turno-1-asistencia");
    },
    hayDatosCuestionario() {
      var a = this.actual;
      return (
        a.t1MesaInstalada !== null ||
        a.t1InstaladaSoloMiembrosMesa !== null ||
        a.t1InstaladaConPersonaDeLaFila !== null ||
        a.t1RangoHoraInstalacion !== null ||
        !!a.t1RangoHoraInstalacionDetalle ||
        a.t1NoInstalAusenciaMiembrosMesa !== null ||
        a.t1NoInstalFaltaMaterialElectoral !== null ||
        a.t1NoInstalDesastresNaturales !== null ||
        a.t1NoInstalOtros !== null ||
        !!a.t1NoInstalOtrosDetalle ||
        a.t1MaterialElectoralCompletoOnpe !== null ||
        !!a.t1MaterialElectoralCompletoOnpeDetalle ||
        a.t1PresenciaPersoneros !== null ||
        !!a.t1PresenciaPersonerosOrganizacionParamIds ||
        a.t1PropagandaCercaMesa !== null ||
        !!a.t1PropagandaCercaMesaOrganizacionParamIds ||
        !!a.t1PropagandaCercaMesaDetalle ||
        a.t1FacilIdentificarNumeroMesa !== null ||
        !!a.t1FacilIdentificarNumeroMesaDetalle ||
        a.t1AtencionPreferencial !== null ||
        !!a.t1AtencionPreferencialDetalle ||
        a.t1IncidenteLimitaLaborObservador !== null ||
        !!a.t1IncidenteLimitaLaborObservadorDetalle ||
        a.t1ActoIntimidacionOViolencia !== null ||
        !!a.t1ActoIntimidacionOViolenciaDetalle
      );
    },
    resetCuestionarioTurno() {
      var a = this.actual;
      a.t1MesaInstalada = null;
      a.t1InstaladaSoloMiembrosMesa = null;
      a.t1InstaladaConPersonaDeLaFila = null;
      a.t1RangoHoraInstalacion = null;
      a.t1RangoHoraInstalacionDetalle = null;
      a.t1NoInstalAusenciaMiembrosMesa = null;
      a.t1NoInstalFaltaMaterialElectoral = null;
      a.t1NoInstalDesastresNaturales = null;
      a.t1NoInstalOtros = null;
      a.t1NoInstalOtrosDetalle = null;
      a.t1MaterialElectoralCompletoOnpe = null;
      a.t1MaterialElectoralCompletoOnpeDetalle = null;
      a.t1PresenciaPersoneros = null;
      a.t1PresenciaPersonerosOrganizacionParamId = null;
      a.t1PresenciaPersonerosOrganizacionParamIds = null;
      a.t1PropagandaCercaMesa = null;
      a.t1PropagandaCercaMesaOrganizacionParamId = null;
      a.t1PropagandaCercaMesaOrganizacionParamIds = null;
      a.t1PropagandaCercaMesaDetalle = null;
      a.t1FacilIdentificarNumeroMesa = null;
      a.t1FacilIdentificarNumeroMesaDetalle = null;
      a.t1AtencionPreferencial = null;
      a.t1AtencionPreferencialDetalle = null;
      a.t1IncidenteLimitaLaborObservador = null;
      a.t1IncidenteLimitaLaborObservadorDetalle = null;
      a.t1ActoIntimidacionOViolencia = null;
      a.t1ActoIntimidacionOViolenciaDetalle = null;
    },
    seleccionarTipoRegistroAsistencia(valor) {
      if (this.actual.t1TipoRegistroAsistencia === valor) return;
      if (!this.validarRegistroAsistencia() || !this.datosAsistenciaValidos) {
        this.$bvToast.toast("Completa el Nombre del Observador, DNI y Nro. de Mesa antes de continuar.", { title: "Registro de Asistencia", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return;
      }
      if (this.hayDatosCuestionario()) {
        var vm = this;
        this.$bvModal.msgBoxConfirm(
          "Se borrarán todos los datos ya registrados en el cuestionario de esta ficha. ¿Deseas continuar?",
          {
            title: "Confirmar cambio",
            okTitle: "Sí, borrar y continuar",
            cancelTitle: "Cancelar",
            okVariant: "danger",
            centered: true,
          }
        ).then(function (confirmado) {
          if (!confirmado) return;
          vm.resetCuestionarioTurno();
          vm.$set(vm.actual, "t1TipoRegistroAsistencia", valor);
        });
        return;
      }
      this.$set(this.actual, "t1TipoRegistroAsistencia", valor);
    },
    limpiarInstalacionMesa(instalada) {
      this.actual.t1MesaInstalada = instalada;
      this.actual.t1InstaladaSoloMiembrosMesa = null;
      this.actual.t1InstaladaConPersonaDeLaFila = null;
      this.actual.t1RangoHoraInstalacion = null;
      this.actual.t1RangoHoraInstalacionDetalle = null;
      this.actual.t1NoInstalAusenciaMiembrosMesa = null;
      this.actual.t1NoInstalFaltaMaterialElectoral = null;
      this.actual.t1NoInstalDesastresNaturales = null;
      this.actual.t1NoInstalOtros = null;
      this.actual.t1NoInstalOtrosDetalle = null;
      // Bloque 3 (Entorno y Presencia) sólo aplica si la mesa fue instalada.
      if (instalada !== true) {
        this.actual.t1PresenciaPersoneros = null;
        this.actual.t1PresenciaPersonerosOrganizacionParamId = null;
        this.actual.t1PresenciaPersonerosOrganizacionParamIds = null;
        this.actual.t1PropagandaCercaMesa = null;
        this.actual.t1PropagandaCercaMesaOrganizacionParamId = null;
        this.actual.t1PropagandaCercaMesaOrganizacionParamIds = null;
        this.actual.t1PropagandaCercaMesaDetalle = null;
        this.actual.t1FacilIdentificarNumeroMesa = null;
        this.actual.t1FacilIdentificarNumeroMesaDetalle = null;
        this.actual.t1AtencionPreferencial = null;
        this.actual.t1AtencionPreferencialDetalle = null;
      }
    },
    limpiarCampoConOrganizacion(campoBool, campoOrganizacion) {
      this.actual[campoBool] = false;
      this.actual[campoOrganizacion] = null;
      this.actual[campoOrganizacion + "s"] = null;
    },
    limpiarPropagandaMesa() {
      this.actual.t1PropagandaCercaMesa = false;
      this.actual.t1PropagandaCercaMesaOrganizacionParamId = null;
      this.actual.t1PropagandaCercaMesaOrganizacionParamIds = null;
      this.actual.t1PropagandaCercaMesaDetalle = null;
    },
    inicializarGuardado() {
      if (!this.intervaloAutoGuardado || this.intervaloAutoGuardado <= 0) return;
      if (!this.ui.tieneCargaInicial || this.ui.estaCargandoDatos || !this.auth.autorizadoEdicionTurno) return;
      var vm = this;
      clearTimeout(this.temporizadorGuardado);
      this.temporizadorGuardado = setTimeout(function () {
        if (!vm.ui.estaCargandoDatos && !vm.ui.estaGuardando && vm.isDirty) vm.doGuardado(true);
      }, this.intervaloAutoGuardado);
    },
    actualizarBaseDiferente(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      var vActual = JSON.stringify(fichaActual[propiedad]);
      var vGuardado = JSON.stringify(fichaGuardado[propiedad]);
      var vActualizado = JSON.stringify(fichaActualizada[propiedad]);
      return (vActual == vGuardado && vGuardado != vActualizado) ? fichaActualizada[propiedad] : fichaActual[propiedad];
    },
    doCargarFicha: async function () {
      this.ui.estaCargandoDatos = true;
      var model = { mesaVotacionId: this.mesaVotacionId, procesoElectoralId: this.procesoElectoralId };

      await this.$http.post(this.apiRoute("Sheet", "GetFichaMesaTurnoUno"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var ficha = response.body.data.ficha;
          var tempActual = this.cloneObject(this.actual);
          var tempGuardado = this.cloneObject(this.guardado);

          Object.keys(tempActual).forEach(c => { tempActual[c] = this.actualizarBaseDiferente(c, tempActual, tempGuardado, ficha); });

          this.actual = this.cloneObject(tempActual);
          this.guardado = this.cloneObject(this.actual);
          this.auth = response.body.data.auth;
          this.numeroMesaEsperado = response.body.data.numeroMesaEsperado;
          this.localNombre = response.body.data.localNombre;
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
    },
    doGuardado: async function (omitirNotificacion) {
      if (this.ui.estaGuardando) return;
      if (omitirNotificacion == true && !this.datosAsistenciaValidos) return false;
      if (!this.validarRegistroAsistencia() || !this.datosAsistenciaValidos) {
        if (omitirNotificacion != true) this.$bvToast.toast("Completa el Nombre del Observador, DNI y Nro. de Mesa antes de guardar.", { title: "Mesa - Turno 1", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }
      if (this.actual.t1MesaInstalada === true) {
        if (this.actual.t1PropagandaCercaMesa === true && this.parsePartidoIds(this.actual.t1PropagandaCercaMesaOrganizacionParamIds).length === 0) {
          if (omitirNotificacion != true) this.$bvToast.toast("Selecciona al menos una organización política para la pregunta 3.", { title: "Mesa - Turno 1", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
          return false;
        }
      }
      if (!this.isFormValid("frm-mesa-turno-1")) {
        if (omitirNotificacion != true) this.$bvToast.toast("Hay campos con valores incorrectos.", { title: "Mesa - Turno 1", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }

      var actualClone = this.cloneObject(this.actual);
      var model = this.cloneObject(this.actual);
      model.mesaVotacionId = this.mesaVotacionId;
      model.procesoElectoralId = this.procesoElectoralId;

      var guardadoExitoso = false;
      this.ui.estaGuardando = true;
      await this.$http.post(this.apiRoute("Sheet", "EditFichaMesaTurnoUno"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.guardado = actualClone;
          if (omitirNotificacion != true) this.$bvToast.toast("Los cambios se han guardado correctamente.", { title: "Mesa - Turno 1", autoHideDelay: 5000, variant: "success", appendToast: false, solid: true });
          guardadoExitoso = true;
          this.doCargarFicha();
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.estaGuardando = false;
      return guardadoExitoso;
    },
  },
  watch: {
    actual: {
      deep: true,
      handler() {
        if (this.intervaloAutoGuardado && this.intervaloAutoGuardado > 0 && this.ui.tieneCargaInicial && !this.ui.estaCargandoDatos && this.auth.autorizadoEdicionTurno) {
          this.inicializarGuardado();
        }
      },
    },
  },
  mounted() {
    this.initParsley();
    this.fetchPartidosPoliticos();
    this.doCargarFicha();
  },
  beforeDestroy() {
    clearTimeout(this.temporizadorGuardado);
  },
};
</script>

<style scoped>
.card-body .btn-outline-secondary {
  background-color: #fff;
}
</style>
